class DateHelper {
  static isDateBeforeNbDays(
    expirationDate: Date | undefined,
    days: number,
  ): boolean {
    if (!expirationDate) {
      return false;
    }
    const today = new Date();
    const xDayLater = new Date(today.setDate(today.getDate() + days));

    return expirationDate < xDayLater;
  }

  static isTodayAfterDatePlusDays(
    dateString: string | undefined,
    days: number,
  ): boolean {
    if (!dateString) {
      return false;
    }

    const baseDate = new Date(dateString);
    if (isNaN(baseDate.getTime())) {
      return false; // Invalid date string
    }

    const thresholdDate = new Date(baseDate);
    thresholdDate.setDate(thresholdDate.getDate() + days);

    const now = new Date();

    return now > thresholdDate;
  }

  static dayAndMonthFromDate(input: Date | string): string {
    const date = typeof input === "string" ? new Date(input) : input;

    if (isNaN(date.getTime())) {
      throw new Error("Invalid date");
    }

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // getMonth() returns month from 0-11, so add 1
    return `${day}/${month}`;
  }

  static qcpFormattedDate(isoString: string): string {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} à ${hours}h${minutes}`;
  }
}

export default DateHelper;
